import api from '@/libs/axiosInstance';
import type { ApiResponse } from '@fluenceur/types';
import { useMutation } from '@tanstack/react-query';

const verifyPasswordResetTokenRequest = async (token: string): Promise<ApiResponse> => {
  const response = await api.get<ApiResponse>(`/auth/password-reset/verify?token=${token}`);

  if (response.data?.success !== true) {
    throw new Error(response.data?.message || 'Invalid or expired reset token');
  }

  return response.data;
};

export const useVerifyPasswordResetTokenAction = () =>
  useMutation<ApiResponse, Error, string>({
    mutationFn: verifyPasswordResetTokenRequest,
  });
